/**
 * Check if a date is valid
 * @param  {String} value | input value
 * @param {Object} options
 * @returns {String|null} returns null which validates as true in validate.js or an error string
 */
const dateNL = function (value, options) {
  if (!value) return null
  const [day, month, year] = value.split('-')
  // This instruction will create a date object
  const m = parseInt(month, 10) - 1
  const d = parseInt(day, 10)
  const y = parseInt(year, 10)
  const date = new Date(y, m, d)
  const validDate = date.getFullYear() === y && date.getMonth() === m && date.getDate() === d
  if (day && month && year && !validDate) {
    return options.message
  }
  return null
}
export default dateNL
